export default __webpack_public_path__ + "static/media/Node-express.97db61fe.svg";